import FormLabel from '@rio-cloud/rio-uikit/FormLabel';
import { useId } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FeatureToggles, useFeatureToggle } from '../../../../../../configuration/featureToggle/toggleHook';
import { TextInput } from '../../../../sharedComponents/sidebar/TextInput';
import { MeansOfTransport } from '../../../transportAssignment.types';
import { ValidatedFormGroup } from '../ValidatedFormGroup';
import { AutoSuggestAssetInput } from './AutoSuggestAssetInput';
import { ValidationResult } from '../../../../sharedComponents/validationResult.type';

type TransportMeansIdFormFieldProps = {
    meansOfTransport: MeansOfTransport | undefined;
    setMeansOfTransportId: (value: { id?: string; assetId?: string }) => void;
    validation: ValidationResult;
    isFormDisabled: boolean;
};

export const MeansOfTransportFormInput = ({
    meansOfTransport,
    setMeansOfTransportId,
    validation,
    isFormDisabled,
}: TransportMeansIdFormFieldProps) => {
    const inputId = useId();
    const intl = useIntl();

    const inputProps = {
        id: inputId,
        placeholder: intl.formatMessage({
            id: 'outboundOrderBook.transportAssignments.sidebar.confirmationForm.meansOfTransportId.placeholder',
        }),
        value: meansOfTransport?.id ?? '',
        disabled: isFormDisabled,
    };

    const supportingText = intl.formatMessage({
        id: 'outboundPortal.transportAssignments.sidebar.assignmentInformation.transportMeansId.info',
    });

    return (
        <div className="width-50pct padding-right-5">
            <FormLabel htmlFor={inputId} supportingText={supportingText} className="flex-column ellipsis-1">
                <FormattedMessage id="outboundOrderBook.transportAssignments.sidebar.confirmationForm.meansOfTransportId" />
            </FormLabel>
            <ValidatedFormGroup validation={validation}>
                {useFeatureToggle(FeatureToggles.TRACKING, false).value ? (
                    <AutoSuggestAssetInput
                        meansOfTransport={meansOfTransport}
                        setMeansOfTransport={setMeansOfTransportId}
                        inputProps={inputProps}
                    />
                ) : (
                    <TextInput
                        setValue={(assetName) => setMeansOfTransportId({ id: assetName, assetId: undefined })}
                        {...inputProps}
                    />
                )}
            </ValidatedFormGroup>
        </div>
    );
};
